import { matchPath } from 'react-router-dom';
import paths from '../routes/paths';
// check if we are on /form/* or survey/* page
export function useSkipAccessFetch() {
  return (
    matchPath(window.location.pathname, { path: paths.get('form') }) !== null ||
    matchPath(window.location.pathname, { path: paths.get('survey') }) !== null
  );
}
